import 'css-chunksrc/client/common/tagList/buttonTagForm/styles.scss';export default {
  "iconBox": "_iconBox_1ezm3_1",
  "icon": "_icon_1ezm3_1",
  "form": "_form_1ezm3_14"
};